// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nh1[data-v-194b7022] {\n  font-size: 30px;\n  font-weight: bold;\n}\n\n", ""]);
// Exports
module.exports = exports;
